var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSoundX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.058,
    height: 25.059,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-sound-x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    className: "cls-1",
    d: "M657.006-118.947a12.544 12.544 0 01-12.529-12.53 12.543 12.543 0 0112.529-12.529 12.544 12.544 0 0112.529 12.529 12.544 12.544 0 01-12.529 12.53zm0-23.884a11.367 11.367 0 00-11.354 11.354 11.367 11.367 0 0011.354 11.355 11.368 11.368 0 0011.355-11.355 11.368 11.368 0 00-11.355-11.354z",
    transform: "translate(-644.477 144.006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    className: "cls-1",
    d: "M659.77-133.431l1.77-1.77a.944.944 0 000-1.138.769.769 0 00-1.012 0l-1.77 1.77-1.9-1.77a.769.769 0 00-1.012 0 .769.769 0 000 1.012l1.77 1.77-1.77 1.77a.769.769 0 000 1.012.958.958 0 00.506.253.959.959 0 00.506-.253l1.77-1.77 1.77 1.77a.959.959 0 00.506.253.959.959 0 00.506-.253.769.769 0 000-1.012z",
    transform: "translate(-641.519 145.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    className: "cls-1",
    d: "M656.4-127.978v-9.956a.7.7 0 00-.379-.632.692.692 0 00-.759.126l-4.047 3.288h-2.15a.816.816 0 00-.759.759v2.908a.816.816 0 00.759.759h2.15l3.966 3.348a.55.55 0 00.073.062.711.711 0 00.431.145.715.715 0 00.716-.7c.006.001-.001-.107-.001-.107z",
    transform: "translate(-643.463 145.428)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoundX);
export default __webpack_public_path__ + "static/media/icon-sound-x.f1eb10c8.svg";
export { ForwardRef as ReactComponent };